import { div } from '@mui/system'
import React,{useEffect, useState} from 'react'
import { toast } from 'react-hot-toast'
import { ButtonFilled, ButtonFilledAutoWidth } from '../../../components/button'
import { TextAreaInput1, TextInput } from '../../../components/input'
import { CreateDepartmentService, UpdateDepartmentService } from '../../../services/DepartmentServices'
import { useNavigate, useLocation } from 'react-router-dom'
import { MobileBackOption } from '../../../components/appbars/mobile/DashboardMobile'
import SettingsMenu from '../../staticscreens/SettingsMenu'
import GoBack from '../../../components/back/GoBack'
import { message,Select } from 'antd'
import { CreateFollowupService, UpdateFollowupService } from '../../../services/admin/FollowupServices'
import { CreateDigitalCardService, UpdateDigitalCardService } from '../../../services/admin/DigitalCardServices'
import {BiCheckbox,BiCheckboxSquare} from 'react-icons/bi'
import { GetDigitalCardDistributorSearchService } from '../../../services/admin/DigitalCardDistributorServices'
import { CreateFranchiseRequestService, UpdateFranchiseRequestService } from '../../../services/admin/FranchiseListServices'
import { franchiseStepsList,franchiseCityList } from './constant'


function FranchiseRequestCE() {
 
  const [data,setdata] = useState({name:'',mobile:'',city:'',status:'',remarks:''});  
  const [error,seterror] = useState({name:'',mobile:'',city:'',status:'',remarks:''}); 
  
  const {state} = useLocation();
  const pathname = window.location.pathname.split('/').pop();
  const navigate = useNavigate();

  const [distributors,setdistributors] = useState([])

  const typeArr = [{label:'Free',value:'free'},{label:'Paid',value:'paid'}]


  useEffect(()=>{
    if(state?._id !== null && state?._id !== undefined){
      let d = {...data,...state}
      if(state?.status){
        d.status = franchiseStepsList.find((t)=>t.value === state.status)?.value
      }
      setdata({...data,...d})
    }

  },[state])

  function handlechange(e){
    setdata({...data,[e.target.name] : e.target.value})
    seterror({...error,[e.target.name]:''})
  }


  async function submitform(){
    if(!data.name){
        seterror({...error,name:'Name field is required *'})
    }else if(!data.mobile){
        seterror({...error,mobile:'Mobile field is required *'})
    }else if(!data.city){
        seterror({...error,city:'City field is required *'})
    }else if(!data.status){
        seterror({...error,status:'Status field is required *'})
    }else{
        if(state?._id === undefined || state?._id === null){
        let send_data = {...data}
        send_data.status = franchiseStepsList.find((t)=>t.value === data.status)?.value
       
        const response = await CreateFranchiseRequestService(send_data)
        if (response.status === 201) {
          resetform()
          toast.success('Franchise Request Created Successfully')
        }   
        if(response.status === 422){
          seterror({...error,days:response?.data?.errors?.days})
        } 
      }else{
        let send_data = {...data}
        send_data.status = franchiseStepsList.find((t)=>t.value === data.status)?.value
        const response = await UpdateFranchiseRequestService(send_data,state?._id)
        if (response.status === 200) {
          resetform()
          navigate(-1)
          toast.success('Franchise Request Updated Successfully')
        }   
        if(response.status === 422){
           seterror({...error,days:response?.data?.errors?.days})
        } 
      }
  }
  }


  function resetform(){
    setdata({name:'',mobile:'',city:'',status:'',remarks:''})
    seterror({name:'',mobile:'',city:'',status:'',remarks:''})
  }
  
  async function handleSelect(e,e1){
    if(e1 === 'status'){
      setdata({...data,status:franchiseStepsList.find((t)=>t.value === e)?.value})
      seterror({...error,status:''})
    }
    if(e1 === 'city'){
      setdata({...data,city:franchiseCityList.find((t)=>t.value === e)?.value})
      seterror({...error,city:''})
    }
  }

  return (
    <div className='md:flex '>

    <div className='hidden md:block'>
    <SettingsMenu />
    </div> 
    <div className='sm:w-full lg:w-72 px-4 pt-5' >


        <GoBack /> 

        <h6 className='font-[700]'>{(state?.id !== null && state?.id !== undefined) ? 'Edit' : 'Add'} Franchise Request</h6>
        <h6 className='text-[10px] bg-slate-100 p-2 font-[500] leading-snug' >Use the below form to create or edit the <b> Franchise Request</b> for your clients segregate followup.</h6>
     

        <TextInput 
            label={'Name'}  
            variant="standard"
            name="name"
            type="text"
            error={error.name}
            value={data.name}
            handlechange={handlechange}
            placeholder="Enter your name"
            disabled={pathname === 'edit'}
            InputLabelProps={{
                style: { color: '#fff', }, 
            }}/>

          <TextInput 
            label={'Mobile'}  
            variant="standard"
            name="mobile"
            type="number"
            error={error.mobile}
            value={data.mobile}
            handlechange={handlechange}
            placeholder="Enter your mobile"
            InputLabelProps={{
                style: { color: '#fff', }, 
            }}/>  

         

            <div>
             <h6 className='text-[11px] mb-1 mt-2'>Status </h6>
                <Select
                  showSearch
                  value={data.status} 
                  filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
                  bordered={false}
                  placeholder="" 
                  onChange={(e)=>handleSelect(e,'status')} 
                  options={franchiseStepsList} 
                  className='w-full border outline-0 focus:outline-0 focus:ring-0 focus:border-none  focus:border-transparent focus:ring-offset-0 focus:shadow-none'
      
                  />
            </div> 

             <div>
             <h6 className='text-[11px] mb-1 mt-2'>City </h6>
                <Select
                  showSearch
                  value={data.city} 
                  filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
                  bordered={false}
                  placeholder="" 
                  onChange={(e)=>handleSelect(e,'city')} 
                  options={franchiseCityList} 
                  className='w-full border outline-0 focus:outline-0 focus:ring-0 focus:border-none  focus:border-transparent focus:ring-offset-0 focus:shadow-none'
      
                  />
            </div> 

            <TextAreaInput1 
              label={'Remarks'}  
              variant="standard"
              name="remarks"
              type="text"
              error={error.remarks}
              value={data.remarks}
              handlechange={handlechange}
              placeholder=""
              InputLabelProps={{
                  style: { color: '#fff', }, 
              }}/>

           


               

        <div className='mt-5'>
        <ButtonFilledAutoWidth btnName={(state?._id !== null && state?._id !== undefined) ? "UPDATE FRANCHISE REQUEST" : "ADD FRANCHISE REQUEST"}  onClick={submitform} />  
        </div>


    </div>
    </div>
  )
}

export default FranchiseRequestCE